/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { createSlice } from '@reduxjs/toolkit';
import G17Client from '../services/G17Client';
import { ScorecardResponse } from '../types/scorecard';

interface InitialState {
  initiativeId?: string;
  data?: ScorecardResponse;
  errorMessage?: string;
}

const initialState: InitialState = {
}

const publicScorecard = createSlice({
  name: 'publicScorecard',
  initialState,
  reducers: {
    load: (state, action) => {
      return { ...initialState, initiativeId: action.payload };
    },
    loaded: (state, action) => {
      return { ...state, data: action.payload }
    },
    error: (state, action) => {
      return { ...state, errored: true, errorMessage: action.payload };
    }
  }
})

export const { load, loaded, error } = publicScorecard.actions

export const loadPublicScorecardsByInitiativeId = (initiativeId: string, token: string) => {
  return async (dispatch: any, getState: () => any) => {

    const state: InitialState = getState().publicScorecard;
    if (initiativeId === state.initiativeId) {
      return;
    }

    dispatch(load(initiativeId));

    G17Client.getPublicScorecard(initiativeId, token).then(
      (scorecard: ScorecardResponse) => {
        dispatch(loaded(scorecard))
      },
      (err: Error) => {
        dispatch(error(err.message));
      }
    )
  };
}

export default publicScorecard.reducer
